class EaccountingController extends AbstractIntegrationController
	@register()
	@inject '$filter',
		'$q'
		'$stateParams'
		'$window'
		'ConfigurationService'
		'EntityAttributeService'
		'configuration'
		'configurationOptions'
		'IntegrationRepository'
		'IntegrationService'
		'ShopRepository'
		'ToastService'
		'Products'
		'priceRegions'
		'shops'
		'vatRates'
		'TenderTypes'
		'UserInformation'
		'BACKEND_TRANSACTION_CARD_TYPE'

	integrationId: 'eaccounting'

	initialize: ->
		@integrationError = @$stateParams.error ? false
		@updating = @configuration.is_active == true
		@additionalButtonsTemplate = '@app/integration/eaccounting/eaccounting.additional-buttons.view.html'

		if !@isConnected()
			@updating = false

			return

		@ensureObjectsInConfiguration(
			@configuration,
			['user_vat_sum', 'user_product_sum', 'tender_types', 'card_types']
		)

		@configurationOptions.cost_centers = _.filter(@configurationOptions.cost_centers, {IsActive: true})

		notAssortedVatRates = @configurationOptions.vat_rates

		@cardTypes = @BACKEND_TRANSACTION_CARD_TYPE
		@tenderTypes = @TenderTypes.data

		if !notAssortedVatRates
			if angular.isUndefined @configurationOptions.error
				message = 'wbo.integration.eaccounting.no.vat.accounts'
			else
				message = @configurationOptions.error
				@configurationOptions =
					accounts: {}
					cost_centers: []

			@showContent = false
			@integrationError = message

			@ToastService.add(
				message,
				@integrationId,
				@$filter('translate')('general.error'),
				'error'
			)

			return

		vatRates = {}

		for vatRate in notAssortedVatRates
			vatRates[vatRate.Id] = vatRate

		@configurationOptionsAccounts = Object.keys(@configurationOptions.accounts).map (key) =>
			account = @configurationOptions.accounts[key]

			if account.VatCodeId
				account.VatCode = vatRates[account.VatCodeId]
				account.VatCode.VatRateForDisplay = "(#{account.VatCode.Description} #{account.VatCode.VatRate * 100}%)"

			return @configurationOptions.accounts[key]

		if @$stateParams.code? && @$stateParams.state?
			if @IntegrationConfiguration.data.refresh_token && @IntegrationConfiguration.data.redirect_uri
				@ToastService.add(
					@integrationId,
					@$filter('translate')('general.integration'),
					@$filter('translate')('alert.saved'),
					'success'
				)
			else
				@ToastService.add(
					@integrationId,
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.error'),
					'error'
				)

		@accounts = @IntegrationService.getPaymentAccounts()

		if @vatRates.length > 0
			@vatRates.map (vatRate) ->
				vatRate.displayPercentage = parseFloat(parseFloat(vatRate.percentage*100).toFixed(3))

				return vatRate

		@configuration.sync_invoice_orders ?= false

		@hasDefaultVatRate = false
		@defaultVatRate = null

		if @UserInformation.getMasterUser().price_region_id
			if @priceRegions.length > 0 && @priceRegions[0].vat_rate.percentage > 0
				@hasDefaultVatRate = true
				@defaultVatRate = @priceRegions[0].vat_rate
				@defaultVatRate.displayPercentage = parseFloat(parseFloat(@defaultVatRate.percentage * 100).toFixed(3))

		@initializeShopCostCenters()

	initializeShopCostCenters: ->
		if _.isEmpty @configuration.shop_cost_centers
			@configuration.shop_cost_centers = {}

		for shop in @shops
			# Backward Compatible - move cost_center_id from Shop to own configuration
			if !_.isEmpty(shop.attributes.cost_center_id) && !@configuration.shop_cost_centers[shop.id]?
				@configuration.shop_cost_centers[shop.id] = shop.attributes.cost_center_id

	save: ->
		super(@configuration)

	afterDisconnect: ->
		@updating = false
		@configuration =
			is_active: false

	runIntegration: (timestampFrom, timestampTo) =>
		@saving = true

		requestBody =
			timestamp_from: timestampFrom
			timestamp_to: timestampTo

		@IntegrationRepository
			.run @integrationId, requestBody
			.then =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@handleErrors(response)
			.finally =>
				@saving = false

	reconnect: ->
		@$window.location.href = @IntegrationService.getEaccountingRequestUrl()
